module.exports = __webpack_public_path__ + "img/front.6b480f6b.svg";